import { DatePicker, Form } from 'antd';
import React from 'react';

import { FORMAT_DATE_DATEPICKER } from '../../const';
import { ItemType } from '../../types';
import { IFieldStartDate } from './fieldStartDate';

const FieldEndDate: React.FC<IFieldStartDate> = ({ required, disabled }) => {
    return (
        <Form.Item<ItemType>
            label="End date"
            name="endDate"
            rules={[
                { required: required, message: 'Please input date!' },
                // ({ getFieldValue }) => ({
                //     validator(_, value) {
                //         if (!value || !getFieldValue('startDate')) {
                //             return Promise.resolve();
                //         }
                //         if (value.isAfter(getFieldValue('startDate')) || value.isSame(getFieldValue('startDate'))) {
                //             return Promise.resolve();
                //         }
                //         return Promise.reject(new Error('End date must be later than start date!'));
                //     },
                // }),
            ]}
        >
            <DatePicker
                style={{ width: '100%' }}
                format={FORMAT_DATE_DATEPICKER}
                disabled={disabled}
                styles={{
                    popup: {
                        root: { zIndex: 3001 },
                    },
                }}
            />
        </Form.Item>
    );
};

export default React.memo(FieldEndDate);
